import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseRestockStatus } from '../../enums/warehouse-restock-status';
import { WarehouseRestockStatusPipe } from '../../pipes/warehouse-restock-status.pipe';

@Component({
  selector: 'app-warehouse-restock-status',
  imports: [CommonModule, WarehouseRestockStatusPipe],
  templateUrl: './warehouse-restock-status.component.html',
  styleUrl: './warehouse-restock-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseRestockStatusComponent {
  public readonly status = input.required<WarehouseRestockStatus>();
}
